module.exports = __webpack_public_path__ + "img/logo.fb3e5f2e.png";